import { jsx, jsxs } from 'react/jsx-runtime';
import styles from '../styles/chatbot.module.scss.js';
import Button from '@amzn/awsui-components-react/polaris/button';
import { Alert } from '@amzn/awsui-components-react/polaris';

function ErrorContent({ onRefreshClicked }) {
    return (jsx("div", { className: styles['chatbot-content'], children: jsxs(Alert, { type: 'error', header: 'Connection Error', children: [jsx("div", { children: "There was an issue connecting to the server. Please try refreshing the connection." }), jsx("div", { className: styles['refresh-button-wrapper'], children: jsx(Button, { onClick: onRefreshClicked, "data-testid": 'RefreshButton', children: "Refresh" }) })] }) }));
}

export { ErrorContent };
